import { Box, Button, Text, Card } from "@radix-ui/themes";
import { ArrowLeft, Bot, Construction } from "lucide-react";
import { useAuth } from "@/providers/AuthProvider";
import PageTemplate from "@/components/page-template/PageTemplate";

export default function CreateAIAgentPage() {
  const { safeNavigate } = useAuth();

  return (
    <PageTemplate title="Create AI Agent">
      <Box>
        <Button
          variant="ghost"
          onClick={() => safeNavigate("/ai-agents")}
          mb="4"
        >
          <ArrowLeft size={16} />
          Back to AI Agents
        </Button>

        <Card style={{ padding: "48px", textAlign: "center" }}>
          <Construction size={64} color="var(--gray-8)" style={{ margin: "0 auto 24px" }} />
          <Text size="4" weight="bold" mb="3" as="div">
            Create Agent - Coming Soon
          </Text>
          <Text size="2" color="gray" mb="4" as="div">
            The ability to create new AI agents will be available soon.
            For now, you can interact with existing agents from DigitalOcean.
          </Text>
          <Button onClick={() => safeNavigate("/ai-agents")}>
            <Bot size={16} />
            View Available Agents
          </Button>
        </Card>
      </Box>
    </PageTemplate>
  );
}
